import { LightbulbNightOutlineIcon } from './LightbulbNightOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 2C6EE261-B451-4F1F-A260-D34AA0EB341A
 * name lightbulb-night-outline
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-night-outline.svg
 * tags
 * - Home Automation 
 */
export const NiteLightOutlineIcon = LightbulbNightOutlineIcon;
export default NiteLightOutlineIcon